module.exports = __webpack_public_path__ + "img/v-pay.9cbc4ed7.png";